const ko = {
  a11yVideoLabelText: "얼굴 생체 인식 확인을 보여주는 비디오",
  cameraMinSpecificationsHeadingText: "카메라 최소 사양",
  cameraMinSpecificationsMessageText:
    "카메라가 생체 인식 확인에 필요한 최소 사양을 충족하는지 확인하십시오.",
  cameraNotFoundHeadingText: "카메라를 찾을 수 없음",
  cameraNotFoundMessageText:
    "카메라를 감지할 수 없습니다. 카메라가 연결되어 있는지 확인하고 다시 시도하십시오.",
  cancelLivenessCheckText: "생체 인식 확인 취소",
  clientHeaderText: "클라이언트 메시지",
  clientMessageText: "화면의 지침에 따라 얼굴 생체 인식 확인을 완료하십시오.",
  connectionTimeoutHeaderText: "연결 시간 초과",
  connectionTimeoutMessageText:
    "연결 시간이 초과되었습니다. 인터넷 연결을 확인하고 다시 시도하십시오.",
  errorLabelText: "오류",
  faceDistanceHeaderText: "얼굴 거리",
  faceDistanceMessageText:
    "얼굴이 카메라로부터 적절한 거리에 있는지 확인하십시오.",
  goodFitAltText: "얼굴이 잘 정렬되었습니다",
  goodFitCaptionText: "얼굴이 잘 정렬되었습니다. 가만히 계십시오.",
  hintCanNotIdentifyText: "얼굴을 식별할 수 없습니다. 다시 시도하십시오.",
  hintCenterFaceInstructionText: "얼굴을 프레임 중앙에 맞추십시오.",
  hintCenterFaceText: "얼굴을 중앙에 맞추십시오",
  hintCheckCompleteText: "확인 완료",
  hintConnectingText: "연결 중...",
  hintFaceDetectedText: "얼굴 감지됨",
  hintFaceOffCenterText: "얼굴이 중앙에서 벗어났습니다. 조정하십시오.",
  hintHoldFaceForFreshnessText: "확인을 위해 얼굴을 고정하십시오.",
  hintIlluminationNormalText: "조명이 좋습니다",
  hintIlluminationTooBrightText: "조명이 너무 밝습니다",
  hintIlluminationTooDarkText: "조명이 너무 어둡습니다",
  hintMatchIndicatorText: "얼굴 지표를 비교 중...",
  hintMoveFaceFrontOfCameraText: "얼굴을 카메라 앞에 두십시오",
  hintTooCloseText: "카메라에 너무 가깝습니다",
  hintTooFarText: "카메라에서 너무 멀리 있습니다",
  hintTooManyFacesText:
    "얼굴이 너무 많이 감지되었습니다. 프레임에 얼굴이 하나만 있어야 합니다.",
  hintVerifyingText: "확인 중...",
  landscapeHeaderText: "가로 모드 감지됨",
  landscapeMessageText: "생체 인식 확인을 위해 세로 모드로 전환하십시오.",
  multipleFacesHeaderText: "여러 얼굴이 감지되었습니다",
  multipleFacesMessageText:
    "프레임에 얼굴이 하나만 있어야 합니다. 조정하고 다시 시도하십시오.",
  photosensitivityWarningBodyText:
    "이 확인에는 일련의 시각적 자극이 포함됩니다. 광 민감성 문제가 있는 경우 주의해서 진행하십시오.",
  photosensitivityWarningHeadingText: "광 민감성 경고",
  photosensitivityWarningInfoText:
    "불편함을 느끼면 언제든지 확인을 중단할 수 있습니다.",
  photosensitivityWarningLabelText: "위험을 이해했습니다",
  portraitMessageText: "기기를 세로 모드로 유지하십시오.",
  recordingIndicatorText: "녹화 중",
  retryCameraPermissionsText: "카메라 권한 재시도",
  serverHeaderText: "서버 문제",
  serverMessageText:
    "서버에 연결하는 동안 문제가 발생했습니다. 나중에 다시 시도하십시오.",
  startScreenBeginCheckText: "생체 인식 확인 시작",
  timeoutHeaderText: "시간 초과",
  timeoutMessageText: "프로세스가 시간 초과되었습니다. 다시 시도하십시오.",
  tooFarAltText: "얼굴이 카메라에서 너무 멀리 있습니다",
  tooFarCaptionText: "카메라에 가까이 가십시오.",
  tryAgainText: "다시 시도",
  waitingCameraPermissionText: "카메라 권한을 기다리는 중...",
};

export default ko;
